<script setup lang="ts">
import { ModalDefault } from '@shared/ui/modals'
import { NativeSelect } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalLessonsBulkEdit } from '../../../model/lessons/modal-lessons-bulk-edit.hook'
import LessonActiveTutorSelect from '../LessonActiveTutorSelect.vue'
import LessonReassignReason from '../LessonReassignReason.vue'

defineOptions({
  name: 'ModalLessonsBulkEdit',
})

const {
  refTitle,
  refStatusOptions,
  refStatus,
  refIsReasonShown,
  refCategoryOptions,
  refCategory,
  refReasonOptions,
  refReason,
  refTutorId,
  refIsReassignStep,
  refReassignOptions,
  refReassignReason,
  refReassignComment,
  refIsReassignInvalid,
  refSubmitText,
  refIsSaving,
  setStatus,
  setCategory,
  setReason,
  setReassignReason,
  setReassignComment,
  closeReassignStep,
  close,
  submit,
} = useModalLessonsBulkEdit()
</script>

<template>
  <ModalDefault
    show
    class-name="modal-lesson-dialog"
    :title="refTitle"
    :loading="refIsSaving"
    @click:overlay="close"
  >
    <div class="modal-lesson-bulk-edit">
      <LessonReassignReason
        v-if="refIsReassignStep"
        :options="refReassignOptions"
        :reason="refReassignReason"
        :comment="refReassignComment"
        :invalid="refIsReassignInvalid"
        :disabled="refIsSaving"
        @change:reason="setReassignReason"
        @change:comment="setReassignComment"
      />
      <template v-else>
        <NativeSelect
          name="bulk_status"
          label="Status"
          :options="refStatusOptions"
          :value="refStatus"
          :disabled="refIsSaving"
          required
          @change="setStatus"
        />
        <template v-if="refIsReasonShown">
          <NativeSelect
            name="bulk_reason_category"
            label="Reason category"
            :options="refCategoryOptions"
            :value="refCategory"
            :disabled="refIsSaving"
            required
            @change="setCategory"
          />
          <NativeSelect
            name="bulk_reason"
            label="Reason"
            :options="refReasonOptions"
            :value="refReason"
            :disabled="refIsSaving"
            required
            @change="setReason"
          />
        </template>
        <LessonActiveTutorSelect
          v-model="refTutorId"
          :disabled="refIsSaving"
        />
      </template>
    </div>
    <template #controls>
      <div class="modal-lesson-form__controls">
        <BtnPrimary
          :text="refSubmitText"
          color="emerald"
          :disabled="refIsSaving"
          @click="submit"
        />
        <BtnSecondary
          v-if="refIsReassignStep"
          text="Go back"
          color="black"
          :disabled="refIsSaving"
          @click="closeReassignStep"
        />
        <BtnSecondary
          v-else
          text="Cancel"
          color="black"
          :disabled="refIsSaving"
          @click="close"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalLessonForm.scss" />
